var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 7.5013V5.41797C1.66663 3.34297 3.34163 1.66797 5.41663 1.66797H7.49996",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.66797H14.5833C16.6583 1.66797 18.3333 3.34297 18.3333 5.41797V7.5013",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 13.332V14.582C18.3334 16.657 16.6584 18.332 14.5834 18.332H13.3334",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 18.3333H5.41663C3.34163 18.3333 1.66663 16.6583 1.66663 14.5833V12.5",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75004 5.83203V7.4987C8.75004 8.33203 8.33337 8.7487 7.50004 8.7487H5.83337C5.00004 8.7487 4.58337 8.33203 4.58337 7.4987V5.83203C4.58337 4.9987 5.00004 4.58203 5.83337 4.58203H7.50004C8.33337 4.58203 8.75004 4.9987 8.75004 5.83203Z",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 5.83203V7.4987C15.4167 8.33203 15 8.7487 14.1667 8.7487H12.5C11.6667 8.7487 11.25 8.33203 11.25 7.4987V5.83203C11.25 4.9987 11.6667 4.58203 12.5 4.58203H14.1667C15 4.58203 15.4167 4.9987 15.4167 5.83203Z",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75004 12.5V14.1667C8.75004 15 8.33337 15.4167 7.50004 15.4167H5.83337C5.00004 15.4167 4.58337 15 4.58337 14.1667V12.5C4.58337 11.6667 5.00004 11.25 5.83337 11.25H7.50004C8.33337 11.25 8.75004 11.6667 8.75004 12.5Z",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 12.5V14.1667C15.4167 15 15 15.4167 14.1667 15.4167H12.5C11.6667 15.4167 11.25 15 11.25 14.1667V12.5C11.25 11.6667 11.6667 11.25 12.5 11.25H14.1667C15 11.25 15.4167 11.6667 15.4167 12.5Z",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarQrcode);
export default __webpack_public_path__ + "static/media/sidebar-qrcode.25726d798f6306ccecbdefb85e6466b5.svg";
export { ForwardRef as ReactComponent };